<template>
  <div class="_sidebar__toggle__list">
    <div class="_sidebar__toggle__item" v-for="(_item, index) in items" :key="index" v-show="_item.text">
      <md-icon class="_sidebar__toggle__item__icon">{{ _item.icon }}</md-icon>
      <span class="_sidebar__toggle__item__text">{{ _item.text }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'sidepanel-toggle-bar-info',
  props: {
    items: {
      type: Array,
      required: true,
    }
  }
}
</script>

<style lang="scss">
// 
</style>
